const ar = {
  hi: "مرحباً",
  login: "تسجيل الدخول",
  myOrders: "طلباتي",
  logout: "تسجيل الخروج",
  viewFullMenu: "عرض القائمة كاملة",
  featuredItems: "العناصر المميزة",
  featuredItemsDesc: "مختارات مميزة أُعدّت بحب وبمكونات طازجة",
  ourMenu: "قائمتنا",
  selectCategory: "اختر الفئة",
  allCategories: "كل الفئات",
  customizable: "قابل للتخصيص",
  exploreOurMenu: "استكشف قائمتنا",
  exploreOurMenuDesc: "اكتشف أطباقاً لذيذة عبر جميع فئاتك المفضلة",
  home: "الرئيسية",
  call: "اتصال",
  aboutUs: "معلومات عنا",
  contactUs: "اتصل بنا",
  quickLinks: "روابط سريعة",
  viewCart: "عرض السلة",
  ourSpecialties: "أطباقنا المميزة",
  location: "الموقع",
  phone: "الهاتف",
  hours: "ساعات العمل",
  yourcart: "سلة التسوق",
  cartisempty: "سلة التسوق فارغة حالياً. أضف عناصر لإتمام الطلب.",
  yourCartIsEmpty: "سلة التسوق فارغة",
  addItemsToGetStarted: "أضف بعض الأطباق اللذيذة للبدء!",

  itemTotal: "إجمالي العناصر",
  gst: "ضريبة السلع والخدمات",
  vat: "ضريبة القيمة المضافة",
  gstRate: 0.05,
  toPay: "المبلغ المستحق",

  message: "تُطبق الشروط والأحكام",
  term1: "قد تختلف صور الأطباق عن التقديم الفعلي.",
  term2: "العناصر خاضعة للتوفر.",
  term3: "يرجى التواصل معنا لتأكيد الطلب.",
  term4: "مدة التوصيل لكل طلب من 30 إلى 45 دقيقة. نرجو تعاونكم.",

  customerDetails: "بيانات العميل",

  filteredItems: "عذراً، لم يتم العثور على العنصر",
  filteredItemDesc:
    "عذراً، لم يتم العثور على أي عناصر. يرجى البحث ضمن جميع الفئات",
  allRightsReserved: "جميع الحقوق محفوظة.",
  welcomeMessage:
    "مرحباً بكم في {{name}}! نقدم لكم مأكولات لذيذة وأصيلة مُحضّرة بمكونات طازجة ووصفات تقليدية. زورونا لتجربة طعام لا تُنسى.",
  searchPlaceholder: "ابحث عن الفئات أو المنتجات...",
  searchAllCategories: "ابحث في جميع الفئات",
  all: "الكل",
  vegFilter: "نباتي",
  nonVegFilter: "غير نباتي",
  vegOnly: "نباتي",
  categories: "الفئات",
  add: "إضافة",
  addOnsFor: "إضافات لـ",
  addToCart: "أضف إلى السلة",
  restaurantOffline:
    "لا نستقبل الطلبات عبر الإنترنت حالياً. يمكنك تصفّح القائمة.",
  backToHome: "العودة إلى الصفحة الرئيسية",
  welcomeBack: "مرحباً بعودتك",
  createAccount: "إنشاء حساب",
  loginToContinue: "سجّل الدخول للمتابعة",
  signupToGetStarted: "أنشئ حساباً للبدء",

  fullName: "الاسم الكامل",
  enterFullName: "أدخل اسمك الكامل",

  mobileNumber: "رقم الجوال",
  enterMobileNumber: "أدخل رقم الجوال المكون من 10 أرقام",

  emailOptional: "البريد الإلكتروني (اختياري)",
  enterEmail: "example@email.com",

  sendOtp: "إرسال رمز التحقق",
  sendingOtp: "جارٍ إرسال رمز التحقق...",

  verifyOtp: "التحقق من الرمز",
  otpInstruction: "أدخل رمز التحقق المكون من 6 أرقام المرسل إلى هاتفك",

  changeNumber: "تغيير الرقم",
  resendOtp: "إعادة إرسال الرمز",
  resendOtpIn: "إعادة إرسال رمز التحقق خلال <strong>{{seconds}}ث</strong>",

  dontHaveAccount: "ليس لديك حساب؟",
  alreadyHaveAccount: "لديك حساب بالفعل؟",
  signup: "إنشاء حساب",

  otpSentTo: "تم إرسال رمز التحقق إلى {{phone}}",

  creatingAccount: "جارٍ إنشاء الحساب...",

  invalidMobile: "أدخل رقم هاتف صحيح مكوّن من 10 أرقام",
  invalidEmail: "أدخل بريدًا إلكترونيًا صحيحًا",
  otpRequired: "يرجى إدخال رمز التحقق الكامل",

  otpSent: "تم إرسال رمز التحقق بنجاح",
  otpResent: "تمت إعادة إرسال رمز التحقق",
  loginFailed: "فشل تسجيل الدخول",
  signupFailed: "فشل إنشاء الحساب",

  loginSuccess: "تم تسجيل الدخول بنجاح… جارٍ التحويل",
  signupSuccess: "تم إنشاء الحساب بنجاح… جارٍ التحويل",

  somethingWentWrong: "حدث خطأ ما، يرجى المحاولة مرة أخرى",
  otpVerificationFailed: "فشل التحقق من رمز التحقق",
  submit:"إرسال",

  orders: "طلباتي",
  completed: "مكتملة",
  onProcess: "قيد المعالجة",
  cancelled: "ملغاة",
  totalPayment: "إجمالي المبلغ",
  noOrdersFound: "لا توجد طلبات",
  loadingOrders: "جارٍ تحميل الطلبات...",
  orderCancelledOrRemoved:
    "تم إلغاء هذا الطلب أو تمت إزالة العناصر بواسطة الإدارة.",
  showMoreItems: "عرض المزيد من العناصر",
  showFewerItems: "عرض عناصر أقل",

  address: "العنوان",
  recentAddresses: "العناوين الأخيرة",
  noRecentAddresses: "لا توجد عناوين محفوظة.",
  select: "اختيار",

  houseFlat: "رقم المنزل / الشقة",
  area: "المنطقة",
  landmarkOptional: "علامة مميزة (اختياري)",
  pincode: "الرمز البريدي",

  orderingUnavailable: "عذراً، الطلب غير متاح حالياً",
  placeOrderWhatsapp: "إتمام الطلب عبر واتساب",

  yourOrder: "طلبك",
  currentOrder: "الطلب الحالي",
  previousOrders: "الطلبات السابقة",
  newOrder: "طلب جديد",
  item: "الصنف",
  qty: "الكمية",
  note: "ملاحظة",
  addNote: "إضافة ملاحظة",
  ordered: "تم الطلب",
  queued: "في الانتظار",
  preparing: "قيد التحضير",
  delivered: "تم التوصيل",
  pending: "قيد الانتظار",
  orderedItems: "الأصناف المطلوبة",
  totalAmount: "المبلغ الإجمالي",
  placeOrder: "إتمام الطلب",
  placingOrder: "جارٍ إرسال الطلب...",
  noNewItems: "لا توجد عناصر جديدة للطلب",
  waitingForApproval: "في انتظار الموافقة",
  tableRequestPending: "طلب الوصول إلى الجدول الخاص بك معلق. يمكنك تقديم الطلبات بمجرد قبول المطعم لطلبك.",
  browseMenu: "تصفح القائمة",
  itemsInCart: "العناصر في السلة",
  orderSummary: "ملخص الطلب",
  shareOrder: "مشاركة الطلب",
  tableCode: "رمز الطاولة",
  shareCode: "شارك هذا الرمز مع الآخرين على طاولتك",
  processing: "جارٍ المعالجة...",
  orderPlacedSuccessfully: "تم تقديم الطلب بنجاح!",
  redirectingToHome: "جارٍ التحويل إلى الصفحة الرئيسية...",
  total: "الإجمالي",
  items: "عناصر",
  removeItem: "إزالة العنصر",
  packageCharge: "رسوم التغليف",
  callWaiter: "اتصل بالنادل",
  WhatsappMessageHeader: "مرحباً، يرجى الاطلاع على الطلب أدناه.",
  offers: "عروض",
  todaysSpecial: "عرض اليوم الخاص",
  combos: "عروض الكومبو",
};

export default ar;
